export default "__VITE_ASSET__De496$8q__"